// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"b3e20a56","142":"8c2f2d26","184":"429f5918","284":"c6ceb6bb","355":"0305c512","443":"1851980e","473":"258220d6","688":"59caa2c9","699":"189741d2"}[chunkId] + ".chunk.js";
};